<template>
    <b-modal
        hide-footer
        ref="modal-view"
        size="xl"
        :title="modelId > 0 ? 'Edición de instrucción' : 'Nueva instrucción'">
        <b-overlay :show="loading" no-wrap></b-overlay>
        <b-card no-body>
            <b-tabs no-fade pills card small vertical nav-class="nav-style">
                <b-tab title="General" active class="mb-3">

                    <b-tabs v-model="currentStep" justified>
                        <b-tab title="1. Configuración">
                            <b-form @submit.prevent="nextStep">
                                <b-form-row class="pt-3">
                                    <b-form-group
                                        :disabled="unableEdit"
                                        class="col-lg-5"
                                        label="Nombre">
                                        <b-form-input 
                                            :disabled="unableEdit"
                                            type="text" 
                                            v-model="modelInfo.name" 
                                            required/>
                                    </b-form-group>

                                    <b-form-group
                                        :disabled="unableEdit"
                                        class="col-lg-3 text-center"
                                        label="Estado">
                                        <b-form-radio-group
                                            v-model="modelInfo.status"
                                            name="status"
                                            class="mb-1">
                                            <b-form-radio value="active" checked>Activo</b-form-radio>
                                            <b-form-radio value="inactive">Inactivo</b-form-radio>
                                        </b-form-radio-group>
                                    </b-form-group>

                                    <b-form-group
                                        :disabled="unableEdit"
                                        class="col-lg-4"
                                        label="Default">
                                        <b-form-checkbox
                                            v-model="modelInfo.default"
                                            name="default"
                                        >
                                        Usar como instrucciones por defecto. 
                                        </b-form-checkbox>
                                        <small class="text-danger" v-if="modelInfo.default == true">
                                            No se vinculará a ningún proveedor.
                                        </small>
                                    </b-form-group>
                                </b-form-row>

                                <b-form-row>
                                    <b-form-group
                                        :disabled="unableEdit"
                                        class="col-lg-5"
                                        label="Proveedor">
                                        <multiselect
                                            :disabled="unableEdit"
                                            :options="supplierOptions"
                                            v-model="modelInfo.supplier"
                                            :multiple="false"
                                            :show-labels="false"
                                            label="text"
                                            track-by="value"/>
                                    </b-form-group>

                                    <b-form-group
                                        :disabled="unableEdit"
                                        class="col-lg-4 ml-2"
                                        label="Meet&Greet">
                                        <b-form-checkbox
                                            v-model="modelInfo.meetAndGreet"
                                            name="default"
                                        >
                                        Tiene Meet&Greet
                                        </b-form-checkbox>
                                    </b-form-group>

                                    <b-form-group
                                        class="col-lg-12"
                                        label="Zonas"
                                    >
                                        <multiselect
                                            :disabled="unableEdit"
                                            :options="zonesOptions"
                                            v-model="modelInfo.zones"
                                            :multiple="true"
                                            group-values="zones"
                                            group-label="name"
                                            :custom-label="displayLabel"
                                            label="name"
                                            track-by="name"
                                            taggable
                                        />
                                    </b-form-group>

                                    <!-- Show polygons in map -->
                                    <b-form-group
                                        class="col-lg-8"
                                        label="Zonas"
                                        v-if="modelInfo.zones.length > 0"
                                    >
                                        <b-list-group>
                                            <b-list-group-item v-for="(zone, index) in modelInfo.zones" 
                                                :key="index">
                                                <a href="#" @click="showPolygone(zone)">
                                                    [{{ zone.id }}] {{ displayLabel(zone) }} <md-icon icon="place"/>
                                                </a>
                                            </b-list-group-item>
                                        </b-list-group>
                                    </b-form-group>
                           
                                    <b-form-group
                                        class="col-lg-12"
                                        label="Polígono"
                                        v-if="showPolygoneMap"
                                    >
                                        <b-card>
                                            <div id="zones-map" ref="map"></div>
                                        </b-card>
                                    </b-form-group>
                                    <!-- End show polygons in map -->

                                </b-form-row>
                                <b-button type="submit" variant="primary" class="float-right">Siguiente</b-button>
                            </b-form>
                        </b-tab>

                        <b-tab title="2. Instrucciones">
                            <b-form @submit.prevent="nextStep" class="py-3">
                                <b-form-row>
                                    <b-form-group
                                        :disabled="unableEdit"
                                        class="col-lg-4"
                                        label="Latitud">
                                        <b-form-input
                                            class="form-control"
                                            type="text"
                                            v-model="modelInfo.latitude"/>
                                    </b-form-group>
                                    <b-form-group
                                        :disabled="unableEdit"
                                        class="col-lg-4"
                                        label="Longitud">
                                        <b-form-input
                                            class="form-control"
                                            type="text"
                                            v-model="modelInfo.longitude"/>
                                    </b-form-group>
                                </b-form-row>

                                <b-form-row class="mt-3">
                                    <div class="font-weight-bold">
                                        LLegadas <md-icon icon="flight"/>
                                    </div>
                                    <b-form-group
                                        :disabled="unableEdit"
                                        class="col-lg-12"
                                        label="Instrucciones Español">
                                        <VueEditor v-model="modelInfo.instructionsEsArrival"/>
                                        <label class="float-right text-primary text-bold">
                                            Caracteres: {{ modelInfo.instructionsEsArrival.replace(/<\/?[^>]+(>|$)/g, "").length }}
                                        </label>
                                    </b-form-group>

                                    <b-form-group
                                        :disabled="unableEdit"
                                        class="col-lg-12"
                                        label="Instrucciones Ingles">
                                        <VueEditor v-model="modelInfo.instructionsEnArrival"/>
                                        <label class="float-right text-primary text-bold">
                                            Caracteres: {{ modelInfo.instructionsEnArrival.replace(/<\/?[^>]+(>|$)/g, "").length }}
                                        </label>
                                    </b-form-group>
                                </b-form-row>

                                <b-form-row class="mt-3">
                                    <div class="font-weight-bold">
                                        Salidas <md-icon icon="place"/>
                                    </div>

                                    <b-form-group
                                        :disabled="unableEdit"
                                        class="col-lg-12"
                                        label="Instrucciones Español">
                                        <VueEditor v-model="modelInfo.instructionsEsDeparture"/>
                                        <label class="float-right text-primary text-bold">
                                            Caracteres: {{ modelInfo.instructionsEsDeparture.replace(/<\/?[^>]+(>|$)/g, "").length }}
                                        </label>
                                    </b-form-group>

                                    <b-form-group
                                        :disabled="unableEdit"
                                        class="col-lg-12"
                                        label="Instrucciones Inglés">
                                        <VueEditor v-model="modelInfo.instructionsEnDeparture"/>
                                        <label class="float-right text-primary text-bold">
                                            Caracteres: {{ modelInfo.instructionsEnDeparture.replace(/<\/?[^>]+(>|$)/g, "").length }}
                                        </label>
                                    </b-form-group>
                                </b-form-row>

                                <b-button type="submit" variant="primary" class="float-right">Siguiente</b-button>
                                <b-button type="button" variant="secondary" @click="prevStep" class="float-right mr-1">Atrás</b-button>
                            </b-form>
                        </b-tab>

                        <b-tab title="3. Imágenes">
                            <b-form @submit.prevent="submitForm">
                                <b-form-row class="py-3" v-if="modelId == -1">
                                    <b-form-group label="Cargar Imágenes" label-for="images"
                                        class="col-lg-12">
                                        <b-form-file
                                            id="images"
                                            v-model="modelInfo.images"
                                            multiple
                                            accept="image/*"
                                            no-drop
                                            @change="onFileChange">
                                        </b-form-file>
                                        <b-button @click="resetImages" class="m-1">Reset</b-button>
                                    </b-form-group>
                                    <p class="text-info">Peso máximo de la imagen: 1MB. Dimensiones máximas 1024x768</p>
                                    <div v-if="errorMessages.length" class="text-danger w-100 pb-2">
                                        <div v-for="(error, index) in errorMessages" :key="index">{{ error }}</div>
                                    </div>
                                    <div v-if="previewImages.length" class="col-lg-12">
                                        <h6>Previsualización:</h6>
                                        <div class="d-flex flex-wrap">
                                            <div v-for="(img, index) in previewImages" :key="index" 
                                                class="p-1 position-relative">
                                                <div class="number">{{ img.index }}</div>
                                                <b-img :src="img.img" thumbnail fluid width="300" heigth="300"></b-img>
                                            </div>
                                        </div>
                                    </div>
                                </b-form-row>
                                <div class="py-2" v-if="modelId > 0">
                                    <FilesRelated
                                        :model-id="this.modelId"
                                        model-reference="meeting-instructions"
                                        :unableEdit="false"
                                        :validations="validations"
                                        :cols="3"
                                        :file-keys="fileKeys"
                                        @update:counter="(totalFiles)=>setTotalFiles(totalFiles)">
                                    </FilesRelated>
                                </div>
                                <b-button
                                    class="float-right"
                                    :disabled="unableEdit || !isValid"
                                    variant="primary"
                                    type="submit">
                                    {{modelId > 0 ? "Actualizar" : "Guardar"}}
                                </b-button>
                                <b-button type="button"
                                    variant="secondary" 
                                    @click="prevStep"
                                    class="float-right mr-1">
                                    Atrás
                                </b-button>
                            </b-form>
                        </b-tab>
                    </b-tabs>

                    <!-- Show errors on form-->
                    <div class="text-center mb-2">
                        <p class="text-danger"
                            v-if="errorForm != null"
                            v-html="errorForm">
                        </p>
                    </div>
                </b-tab>
            </b-tabs>
        </b-card>
    </b-modal>
</template>

<script>

    import { VueEditor } from "vue2-editor/dist/vue2-editor.core.js";
    import FilesRelated from "@/components/helpers/FilesRelated";
    import Multiselect from "vue-multiselect";
    import api from '../../../api.js'

    const defaultModelInfo = {
        id: -1,
        name: "",
        supplier: null,
        zones: [],
        status: "active",
        default: false,
        meetAndGreet: false,
        instructionsEsArrival : "",
        instructionsEnArrival: "",
        instructionsEsDeparture: "",
        instructionsEnDeparture: "",
        latitude: null,
        longitude: null,
        images: []
    }

    export default {
        components: { Multiselect, FilesRelated, VueEditor },
        props: {
            unableEdit: Boolean,
            successCallback: {
                type: Function,
                required: false,
                default: () => {}
            }
        },
        data() {
            return {
                modelId: -1,
                modelInfo: { ...defaultModelInfo },
                loading: false,
                suppliers: [],
                zonesOptions: [],
                errorForm: null,
                zoned: null,
                map: null,
                zones: [],
                firstFetch: true,
                polygonNotEditableOpts : {
					strokeColor: '#dc3545',
					fillColor: '#dc3545',
					editable:false,
					draggable:false
				},
                drawingManager: null,
                currentStep: 0,
                showPolygoneMap: false,
                previewImages: [],
                fileKeys: [{ label: "Images", keyName: "images[]" }],
                auxTotalFiles:null,
                errorMessages: [],
                isValid: true,
                validations : {
                    size: 1, // MB
                    maxWidth: 1024,
                    maxHeight: 768,
                    type: 'image'
                }
            };
        },
        watch: {
            'modelInfo.zones': {
                handler(newItems) {
                    if (typeof newItems == 'undefined')
                        return
                    let isArrayEmpty = newItems.length === 0;
                    if (isArrayEmpty) {
                        this.resetMap();
                    }
                },
                deep: true // Necesario para observar cambios en el contenido del arreglo
            },
            'modelInfo.default': function(newValue) {
                if (newValue == true) {
                    //this.modelInfo.zones    = []
                    this.modelInfo.supplier = null
                }
            }
        },
        methods: {
            loadModel(id) {

                // Reseteamos el valor de mensaje de error
                this.errorForm = null;
                this.modelId   = id;
                this.map       = null
                this.$refs["modal-view"].show();
                this.fetchModel()
            },
            fetchModel() {
                if (this.modelId > 0) {
                    this.loading = true;
                    api(this).get(`meeting-instructions/${this.modelId}`)
                    .then(res => {
                        this.$emit('update:unableEdit', this.$hasPermission('meetingInstruction.edit'))
                        let model =  this.modelInfo
                        this.modelInfo = {...model, ...res.data }
                        
                        // Set supplier value
                        this.modelInfo.supplier = {
                            value: res.data.supplier.id, text: res.data.supplier.name
                        }

                        let zonesModel = []
                        res.data.zones.forEach(element => {
                            const result = this.zonesOptions.find(group => group.zones.some(zone => zone.id === element.id))
                            let name = ''
                            if (result) {
                                name = result.name + ' ';
                            }
                            zonesModel.push({name: name + element.name, id: element.id})
                        });

                        this.modelInfo.zones = zonesModel
                        this.loading = false
                    })
                    .catch(this.$root.handleRequestError);
                } else {
                    this.cleanVars()
                }
            },
            getSupplierOptions() {
                this.$root.api.get('/suppliers?limit=2000')
                    .then(res => {
                        this.suppliers = res.data.rows;
                    })
                    .catch(this.$root.handleRequestError)
                    .then(() => {
                        this.loading = false;
                    });
            },
            getZonesOptions() {
                this.$root.api.get('/zoned-areas/master?withZones=true')
                    .then(res => {
                        this.zonesOptions = res.data
                    })
                    .catch(this.$root.handleRequestError)
                    .then(() => {
                        this.loading = false;
                    });
            },
            displayLabel(option) {

                // If is selected we set custom name adding the group name to avoid confusion
                const group = this.findGroup(option);
                if (typeof group != 'undefined' && this.modelInfo.zones.includes(option)) {
                    return this.customLabel(option, group)
                }

                // if not, show the name
                return option.name
            },
            customLabel(option, group) {
                return `${group.name} - ${option.name}`
            },
            findGroup(option) {
                // Encuentra y retorna el grupo al que pertenece la opción
                return this.zonesOptions.find(group => group.zones.includes(option));
            },
            showPolygone(zone) {
                // solicitar datos de poligono para renderizar
                this.showPolygoneMap = true
                this.$root.api.get(`/zoned/${zone.id}`)
                    .then(res => {
                        this.zoned = res.data
                        this.initializeMap()
                    })
                    .catch(this.$root.handleRequestError)
                    .then(() => {
                        this.loading = false
                    })
            },
            initializeMap() {
                this.$nextTick(() => {
                    if (this.map == null) {
                        this.initMap()
                    }

                    this.loadZonedArea()
                })
            },
            initMap() {
				this.map = new window.google.maps.Map(this.$refs['map'], {
					center: { lat: 21.1214886, lng: -86.9192742 },
					zoom: 12,
					streetViewControl:false,
				});

                this.drawingManager = new window.google.maps.drawing.DrawingManager(
                    {
                        drawingMode: window.google.maps.drawing.OverlayType.POLYGON,
                        drawingControl: true,
                        drawingControlOptions: {
                            position: window.google.maps.ControlPosition.TOP_RIGHT,
                            drawingModes: ["polygon", "rectangle"]
                        }
                    }
                );
			},
            loadZonedArea() {
                this.loading = true;
                this.resetMap();
                this.initZones([this.zoned])
                this.map.setCenter(this.getCentroid(this.zones[0].polygon));
                this.firstFetch = false;
                this.loading = false;
            },
            resetMap(){
				this.zones.forEach(zone => {
					if(zone.polygon) zone.polygon.setMap(null)
					if(zone.infoWindow) zone.infoWindow.close()
				})
			},
            initZones(zones){
				this.zones = zones.map(zone => {
					let polygon = this.createPolygon(zone.zoneGeoPoints)
					let infoWindow = this.createInfoWindow(zone.name, polygon)
					let auxZone = {
						id: zone.id,
						name: zone.name,
						polygon,
						infoWindow,
					}
					this.setZonePolygonEvents(auxZone)
					return auxZone
				})
			},
            createPolygon(geoPoints){
				let polygone = new window.google.maps.Polygon({
					paths: geoPoints.map(gp => ({lat:parseFloat(gp.latitude),lng: parseFloat(gp.longitude)})),
					...this.polygonNotEditableOpts,
				})
				polygone.setMap(this.map)
				return polygone
			},
            createInfoWindow(zoneName,polygon){
				return new window.google.maps.InfoWindow({
					content: zoneName,
					position:this.getCentroid(polygon),
				});
			},
            getCentroid(polygon){
				let PI=22/7
				let X=0;
				let Y=0;
				let Z=0;
				polygon.getPath().forEach(function (vertex) {
					let lat1=vertex.lat();
					let lon1=vertex.lng();
					lat1 = lat1 * PI/180
					lon1 = lon1 * PI/180
					X += Math.cos(lat1) * Math.cos(lon1)
					Y += Math.cos(lat1) * Math.sin(lon1)
					Z += Math.sin(lat1)
				})
				let Lon = Math.atan2(Y, X)
				let Hyp = Math.sqrt(X * X + Y * Y)
				let Lat = Math.atan2(Z, Hyp)
				Lat = Lat * 180/PI
				Lon = Lon * 180/PI
				return new window.google.maps.LatLng(Lat,Lon);
			},
            setZonePolygonEvents(zone){
				zone.polygon.addListener('drag',() => {
					zone.infoWindow.close()
				})
				zone.polygon.addListener('dragend',() => {
					zone.infoWindow.setOptions({
						position: this.getCentroid(zone.polygon)
					})
				})
				zone.polygon.addListener('dblclick',(event) => {
					event.stop()
					this.selectZone(zone)
				})
				zone.polygon.addListener('rightclick',(event) => {
					if (event.vertex == undefined)  return
					zone.polygon.getPath().removeAt(event.vertex);
				})
			},
            blockPolygons(){
				this.zones.forEach(zone => {
					if (zone.polygon) {
						zone.polygon.setOptions(this.polygonNotEditableOpts)
					}
				})
			},
            selectZone(zone){
				this.editingZone = zone
				// si es zona nueva, inicia la funcion de dibujo
				this.blockPolygons()
				if(this.editingZone.polygon == null) this.drawingManager.setMap(this.map)
                    //habilita la creacion de poligono
				else{
					// si ya existe, solo la habilita para edición
					this.drawingManager.setMap(null) //quita la creacion de poligono
					this.editingZone.polygon.setOptions(this.polygonEditableOpts)
				}
			},
            onFileChange(event) {
                const files = event.target.files
                this.validateImages(files)
            },
            nextStep() {
                if (this.currentStep < 2) {
                    this.currentStep++;
                }
            },
            prevStep() {
                if (this.currentStep > 0) {
                    this.currentStep--;
                }
            },
            submitForm() {

                let rParams = {
                    url: this.modelId > 0 ? `/meeting-instructions/${this.modelId}` : "/meeting-instructions",
                    method: this.modelId > 0 ? "put" : "post"
                };

                if (rParams.method == "get") {
                    rParams["params"] = this.modelInfo;
                } else {
                    rParams["data"] = this.modelInfo;
                }

                api(this).request(rParams).then((res) => {
                    if (res.status == 200 || res.status == 201) {
						if (res.data.error) {
							this.$root.showAlert(res.data.error, {
								variant: "warning"
							});
							return false;
						}

                        if (this.modelId == -1) {
                            if (this.modelInfo.images.length > 0 && res.data.id) {
                                this.submitFiles(this.modelInfo.images, res.data.id)
                            }
						}

                        this.resetModal()
						this.$root.showAlert("OK!");
						if (res.data.id) this.loadModel(res.data.id);
						this.successCallback(res);
					}

                    this.loading = false;
                }).catch(() => {
                    this.loading = false
                    this.error   = true
                }).then(() => {
                })
            },
            submitFiles(files, modelId) {
                // send images to save
                let formData = new FormData()
                files.forEach(element => {
                    formData.append('images[]', element)
                });
               
                return new Promise((resolve,reject)=>{
                    this.$root.api.post(`/meeting-instructions/${modelId}/files`,formData, 
                        { headers:{'Content-Type': 'multipart/form-data'}}).then((res) => {

                        if (res.data.error) {
							this.$root.showAlert(res.data.error, {
								variant: "warning"
							});
							return false;
						}

                        this.$root.showAlert('Archivos cargados')
                        resolve(true)
                    })
                    .catch(reject)
                })
            },
            resetModal() {
                this.currentStep      = 0
                this.previewImages    = []
                this.modelInfo.images = []
            },
            setTotalFiles(totalFiles){
                try{
                    let auxTotalFiles   = totalFiles.find((item)=>{
                        return item.key === "images[]";
                    })
                    this.auxTotalFiles = auxTotalFiles.count;
                }catch(err){
                    console.log(err)
                    this.auxTotalFiles = 0;
                }
            },
            validateImages(files) {

                this.errorMessages = []
                this.isValid       = true


                const maxSize   = 1 * 1024 * 1024; // 1 MB
                const maxWidth  = 1024; // 100px
                const maxHeight = 768; // 100px

                let validCount = 0;

                this.previewImages = []
                Array.from(files).forEach((file, index) => {
                    const reader  = new FileReader();
                    reader.onload = (e) => {
                        this.previewImages.push({img: e.target.result, index: index + 1})
                    };
                    reader.readAsDataURL(file);

                    const img = new Image();
                    img.onload = () => {
                        if (file.size > maxSize) {
                            this.isValid = false
                            this.errorMessages.push(`Imagen ${index + 1}: El peso del imagen no debe ser mayor ${this.validations.size} MB.`);
                        } else if (img.width > maxWidth || img.height > maxHeight) {
                            this.isValid = false
                            this.errorMessages.push(`Imagen ${index + 1}: Las dimensiones de la imagen no deben ser mayor de ${this.validations.maxWidth}x${this.validations.maxHeight}.`);
                        } else {
                            validCount++;
                            if (validCount === files.length) {
                            this.isValid = true;
                            }
                        }
                    };

                    img.src = URL.createObjectURL(file);
                });
            },
            resetImages() {
                this.modelInfo.images = []
                this.previewImages    = []
                this.errorMessages    = []
                this.isValid = true
            },
            cleanVars() {
                this.modelInfo     = { ...defaultModelInfo}
                this.previewImages = []
                this.isValid       = true
                this.errorMessages = []
            }
        },
        computed: {
            supplierOptions() {
                return this.suppliers.map(rp => ({ value: rp.id, text: rp.name }));
            },
            isRequired() {
                return this.modelInfo.default;
            },
            characterCount() {
                return this.modelInfo.instructionsEsArrival.replace(/<\/?[^>]+(>|$)/g, "").length;
            }
        },
        mounted() {
            this.getSupplierOptions()
            this.getZonesOptions()
        },
    }
</script>

<style scoped>
	#search-box {
		width: 100%;
		max-width: 400px;
		padding: 5px;
		font-size: 16px;
	}
	.zone-button {
		flex: 1;
	}
	.input-groups {
		width: 100%;
	}

    .number {
        position: absolute;
        top: 0;
        left: 0;
        padding: 4px 10px;
        border-radius: 50%;
        background-color: orange;
        color: white;
    }
</style>
<style >
	#zones-map{
		width: 100%;
		height: 300px;
	}
</style>

<style lang="css">
@import "~vue2-editor/dist/vue2-editor.css";

/* Import the Quill styles you want */
@import '~quill/dist/quill.core.css';
@import '~quill/dist/quill.bubble.css';
@import '~quill/dist/quill.snow.css';
</style>